import React from 'react';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import {safePercent, toHHMM} from 'components/dashboard/admin/admin-coaching-meetings';
import CoachingMeetingCategory from 'records/CoachingMeetingCategory';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';

interface Props {
  /**
   * nullable - the meeting category may be hidden.
   * if so, still display the amount so #s match
   */
  category?: CoachingMeetingCategory;
  metric: any;
  maxMeetingTime: number;
}

export const SquaredOffMiniBar: React.FC<Props> = ({category, metric, maxMeetingTime}) => {
  const pct = safePercent(metric.value || 0, maxMeetingTime);

  return (
    <div className="squared-off-mini-bar" style={{width: `${pct}%`}}>
      <GenericTooltip
        positionTop
        hoverBehavior
        delay={TOOLTIP_DELAY}
        tooltip={
          <div>
            {toHHMM(metric.value)} hours, {category?.name ?? 'Hidden Meeting Category'}
          </div>
        }>
        <div className="colored" style={{backgroundColor: category?.color ?? 'gray'}} />
      </GenericTooltip>
    </div>
  );
};
